(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/models/base.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/models/base.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.models.Base = Backbone.Model.extend({
    getDocumentsFromCMS: function(key) {
      var parentId = {
          personData: svs.terms_integrity.data.config.personDataFolderId,
          terms: svs.terms_integrity.data.config.termsFolderId,
          termsService: svs.terms_integrity.data.config.termsServiceFolderId,
          rules: svs.terms_integrity.data.config.rulesFolderId,
          cookies: svs.terms_integrity.data.config.cookiesFolderId
        },
        options = {
          method: 'GET',
          path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({ parentId: parentId[key], count: 100 }).build()
        },
        self = this;
      svs.core.jupiter.call(
        options,
        function(data) {
          svs.terms_integrity_logger.debug('Successful fetching ' + key);
          var model = {};
          model[key] = data.result;
          self.set(model);
        },
        function(xhr, textStatus, errorThrown) {
          svs.terms_integrity_logger.error('Error in fetching ' + key + ', ' + errorThrown);
        }
      );
    },

    getFaqFromCMS: function(key) {
      var parentId = {
          faqPersonData: svs.terms_integrity.data.config.faqPersonDataFolderId,
          faqCookies: svs.terms_integrity.data.config.faqCookiesFolderId
        },
        options = {
          method: 'GET',
          path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({ parentId: parentId[key], count: 100 }).build()
        },
        self = this;
      svs.core.jupiter.call(
        options,
        function(data) {
          svs.terms_integrity_logger.debug('Successful fetching ' + key);
          var model = {};
          model[key] = data.result;
          self.set(model);
        },
        function(xhr, textStatus, errorThrown) {
          svs.terms_integrity_logger.error('Error in fetching ' + key + ', ' + errorThrown);
        }
      );
    }
  });
})(Backbone, svs);

 })(window);